import PropTypes from "prop-types";
import styles from "./EagleProfileHeader.module.css";

import ChevLeft from "./Images/path.svg";

export function EagleProfileHeader({ name, avatar, onClick, onBack }) {
  const renderNames = () => {
    if (name) {
      const displayNames = name;
      return <span>{displayNames}</span>;
    } else {
      return null;
    }
  };

  return (
    <div className={styles.container} onClick={onClick}>
      <div className={styles.back} onClick={onBack}>
        <img src={ChevLeft} />
      </div>
      <div>
        {Array.isArray(avatar) && avatar.length > 1 ? (
          <div className={styles.avatarMultipleWrapper}>
            <div className={styles.avatarMultiple}>
              <img src={avatar[0]} className={styles.multiple} />
              <img src={avatar[1]} className={styles.multiple2} />
            </div>
          </div>
        ) : (
          <div className={styles.avatar}>
            <img src={Array.isArray(avatar) ? avatar[0] : avatar} />
          </div>
        )}
      </div>
      <div>
        <span className={styles.name}>{renderNames()}</span>
      </div>
    </div>
  );
}

EagleProfileHeader.propTypes = {
  name: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  avatar: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  onClick: PropTypes.func,
  date: PropTypes.string,
  bonus: PropTypes.number,
  pm: PropTypes.number,
  Function: PropTypes.string,
};
